'use client';

import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';

import type { FragmentOf } from '~/client/graphql';
import type { WebAnalyticsFragment } from '~/components/analytics/fragment';

const LazyConsentManagerInner = dynamic(
  () => import('./consent-manager-inner').then((m) => m.ConsentManagerInner),
  { ssr: false },
);

interface ConsentManagerProps extends PropsWithChildren {
  isCookieConsentEnabled: boolean;
  privacyPolicyUrl?: string | null;
  channelId: number;
  analyticsSettings?: FragmentOf<typeof WebAnalyticsFragment> | null;
}

export function ConsentManager({
  children,
  isCookieConsentEnabled,
  privacyPolicyUrl,
  channelId,
  analyticsSettings,
}: ConsentManagerProps) {
  return (
    <>
      {children}
      <LazyConsentManagerInner
        analyticsSettings={analyticsSettings}
        channelId={channelId}
        isCookieConsentEnabled={isCookieConsentEnabled}
        privacyPolicyUrl={privacyPolicyUrl}
      />
    </>
  );
}
